import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {Shower} from "../../parts/shower";
import {Vanity} from "../../parts/vanity";
import {LayoutAbbreviation} from "../../constants";
import {getMetadataByDimensions} from "../../../../../misc/utils";
import ExternallWall from "./externallWall";

export default class WallExL extends ExternallWall {

  constructor(isChild) {
    super(isChild);
    this.partId = "left_shower_wall";
    this.partName = "Left Shower Wall";
    this.translateId = "visualizer.bathroom.walls.left_shower_wall";
    this.wallName = "ExtrusionWallLeft";
    this.shadowName = "Divider Wall";
    this.shadowSmallRoomName = "EX L";
    this.dbName = "EX L";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new WallExL());
  }

  getArrayOfConditions() {
    const parent = this.getParent();
    const layout = parent.layout;
    const layoutAbr = layout.getCurrentLayoutAbbreviation();

    const activeShower = parent.showerTubComboIsActive()
      ? layout.parts[ShowerTubCombo.id]
      : layout.parts[Shower.id];

    const showerSize = activeShower.showerSize();
    const showerDimensions = activeShower.showerDimensions();

    const showerValue = (showerSize === "60in" || showerSize === "30in") ? "Custom" : showerSize;
    let counterTopSize = layout.parts[Vanity.id].counterTopSize();

    counterTopSize = (counterTopSize === '72in' || showerDimensions === "30X8") ? '72in' : counterTopSize;

    if (layoutAbr === LayoutAbbreviation.Small) {
      let wallWidth = (showerDimensions === '30X8') ? 'Thick' : 'Half';
      return [{
        propName: 'Shower',
        propValue: showerSize
      }, {
        propName: 'Width',
        propValue: wallWidth
      }];
    }

    return [{
      propName: 'Shower',
      propValue: showerValue
    }, {
      propName: 'CountertopSize',
      propValue: counterTopSize
    }];

  }

  getShadowConditions() {
    const layout = this.getParent().layout;
    const conditions = this.getArrayOfConditions();
    const showerComboParent = layout.parts[ShowerTubCombo.id];
    const showerParent = layout.parts[Shower.id];
    const layoutAbr = layout.getCurrentLayoutAbbreviation();

    let showerDimensions = showerComboParent.showerTubComboIsActive
      ? showerComboParent.showerDimensions()
      : showerParent.showerDimensions();

    showerDimensions = getMetadataByDimensions(showerDimensions);

    if (!showerComboParent.showerTubComboIsActive && showerDimensions === "Half") {
      if (showerParent.showerFloorIsActive) {
        conditions.push({
          propName: "ShowerPan",
          propValue: ["Threshold"]
        })
      } else if (showerParent.showerPanCombo && showerParent.showerPanCombo.activeFeature && layoutAbr !== LayoutAbbreviation.Small) {
        let showerPanCondition = showerParent.showerPanCombo.activeFeature.metaData["ShowerPan"];
        // console.log('showerPanCondition', showerPanCondition);
        conditions.push({
          propName: "ShowerPan",
          propValue: showerPanCondition
        })
      }
    }
    // console.log('shadow conditions', conditions);
    return conditions
  }

  setShadowFeature() {
    const parentGroup = this.getParent();

    let filteredAvailableFeatures = [];
    if (parentGroup.shadows && parentGroup.shadows.features && parentGroup.shadows.features.length) {
      const layout = parentGroup.layout;
      const layoutAbr = layout.getCurrentLayoutAbbreviation();
      const shadowName = (layoutAbr === LayoutAbbreviation.Small) ? this.shadowSmallRoomName : this.shadowName;

      const filteredFeatures = parentGroup.shadows.features.filter((shadow) => {
        return Array.isArray(shadow.dbFeature.s3Bindings) && shadow.dbFeature.s3Bindings.some(binding => {
          return binding.layout === LayoutAbbreviation.All || binding.layout === layoutAbr
        })
      });
      const compatibleFeatures = filteredFeatures.filter(shadowFeature => {
        return shadowFeature.partName && shadowName && shadowFeature.partName === shadowName
      });
      filteredAvailableFeatures = this.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), compatibleFeatures);
    }
    this.shadowFeature = filteredAvailableFeatures.length ? filteredAvailableFeatures[0] : null;
  }

}
